<template>

    
      <v-timeline-item
      :fill-dot="false"
      :hide-dot="false"
      :left="false"
      :right="false"
      :small="false"
      large
      class="custom"
      color="#4dbac0"
    >
    <template v-slot:icon>
        <v-icon>speaker_notes</v-icon>
      </template>
    <v-card flat v-bind:class="!record.active ? 'close': ''" class="font pa-2">
      <div class="record-head">
        <div class="record-left">
          <span class="hourglass_empty">
            <b>Description Updated</b>
          </span>
          <span class="text-grey">
            |
             {{absoluteDate}} ({{relativeDate}})
            
          </span>


          <div class="record-body mt-1">
            <span >{{record.message}}</span>
          </div>

        </div>
      </div>
      <div class="record-right">
        <submenu :logId="record._id" :parentType="parentType" :storeKey="storeKey" @hideLog="hideLog"/>
      </div>
       </v-card>
      </v-timeline-item>
   

</template>

<script>
var moment = require("moment-timezone");
import submenu from "./submenu.vue"
export default {
  components: {
  submenu
  },
  props: ["record", "parentType", "storeKey"],
  data() {
    return {
      absoluteDate: moment.tz(this.record.createdAt, this.$store.getters.timezone),

      relativeDate: moment
        .tz(this.record.createdAt, this.$store.getters.timezone)
        .fromNow()
    };
  },
  methods: {
    updateTiems() {
      var value = this.record.createdAt;
      this.absoluteDate = moment.tz(value, this.$store.getters.timezone);
      this.relativeDate = moment
        .tz(value, this.$store.getters.timezone)
        .fromNow();
    },
    hideLog(data){
      this.$emit("hideLog", data)
    }
  },
  filters: {},
  mounted() {
    this.updateTiems()
    setInterval(() => {
      this.updateTiems()
    }, 1000);
  },

  computed: {
    
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}
.font{
  font-size: 12px; 
}
</style>
